export const QUESTIONS = [
  {
    id: 'careName',
    type: 'text',
    title: "Who are you looking for care for?",
    subtitle: "Let's start with their given name to personalize this guide.",
    placeholder: "e.g., Terry, Mum, John"
  },
  {
    id: 'relationship',
    type: 'single',
    title: "Who is the care for?",
    options: ["A Parent", "A Partner", "Myself", "Other Relative", "A Friend", "A Client"]
  },
  {
    id: 'targetArea',
    type: 'text',
    title: "Where do you need care?",
    subtitle: "Enter a postcode, town, or city.",
    placeholder: "e.g., E16 or London"
  },
  {
    id: 'timeline',
    type: 'single',
    title: "What is your timeline for finding care?",
    options: [
      "Immediate / Hospital Discharge",
      "Within the next month",
      "Within 1-3 Months",
      "Planning ahead for the future",
      "Just exploring options"
    ]
  },
  {
    id: 'situation',
    type: 'single',
    title: "What is their current living situation?",
    options: [
      "At home but struggling",
      "Hospital discharge pending",
      "Living with family",
      "Currently in a care home (looking to move)",
      "Living independently with some support"
    ]
  },
  {
    id: 'challenges',
    type: 'multiple',
    title: "What physical challenges are they facing?",
    subtitle: "Select all that apply.",
    options: [
      "Washing, dressing, and personal care",
      "Mobility and falls",
      "Managing medication",
      "Preparing meals and eating",
      "Incontinence",
      "Wandering or safety concerns"
    ]
  },
  {
    id: 'nightCare',
    type: 'single',
    title: "Do they require help during the night?",
    options: [
      "No support needed at night",
      "Occasional help (e.g. for the toilet)",
      "Frequent help (multiple times per night)",
      "Constant 24/7 supervision required"
    ]
  },
  {
    id: 'cognitive',
    type: 'single',
    title: "How would you describe their cognitive health?",
    options: [
      "No obvious issues",
      "Mild confusion or forgetfulness",
      "Early stage dementia",
      "Moderate dementia (needs regular prompting)",
      "Advanced dementia (needs constant supervision)"
    ]
  },
  {
    id: 'symptoms',
    type: 'multiple',
    title: "Are they experiencing any of these symptoms?",
    subtitle: "Knowing this helps us suggest specialized dementia care.",
    options: [
      "Anxiety or agitation",
      "Sleep disturbances",
      "Hallucinations or delusions",
      "Repetitive questioning",
      "Social withdrawal",
      "Difficulty communication"
    ]
  },
  {
    id: 'medical',
    type: 'single',
    title: "What level of medical support is needed?",
    options: [
      "General age-related frailty",
      "Needs occasional nursing interventions",
      "Needs 24/7 nursing care",
      "Specialist dementia nursing",
      "Palliative / End of life care"
    ]
  },
  {
    id: 'financial',
    type: 'single',
    title: "What is the estimated financial bracket?",
    subtitle: "Include savings and assets (exclude the home if a partner lives there).",
    options: [
      "Under £14,250 (Full State Support)",
      "£14,250 - £23,250 (Partial Support)",
      "Over £23,250 (Self-Funding)",
      "I'm not sure yet"
    ]
  }
];